import React from 'react';
import PropTypes from 'prop-types';
import SchoolContactInfo from './sidebar/SchoolContactInfo';
import SideBar from './sidebar/SideBar';

class ParentPortalLayout extends React.Component {
  static propTypes = {
    header: PropTypes.object, // Component to render as header.
    sideBar: PropTypes.object, // Array of components to put in side bar.  Default is: [<SchoolContactInfo/>]
    body: PropTypes.object, // Component to render as body.
    navLinks: PropTypes.array, // Array of links to show in sub-nav-bar.  (back to previous page, etc)
  };

  static defaultProps = {
    sideBar: <SideBar className="px-3">
      <SchoolContactInfo/>
    </SideBar>,
    navBar: undefined
  };

  render(){
    const {header,
      sideBar,
      body,
      navBar,
      children
    } = this.props;

    return <div className="react-parent-portal">
      {navBar}

      {header &&
        <section className="summary">
          {header}
        </section>
      }
      <div className="row">
        <section className="checklist">
          {body || children}
        </section>

        {sideBar}
      </div>
    </div>
  }
}

export default ParentPortalLayout;